import { maskMyNumber } from '../../GeneralProfile/useGeneralProfileFlow';
import {
  changeReasonAnswer,
  deriveTaxCategories,
  relationshipLabel,
} from './dependentsSectionSteps';
import type { DependentDraft } from './dependentsSectionTypes';

export function buildDependentSummary(
  d: DependentDraft,
  taxYear: number,
  t: (k: string) => string
): string {
  const L = (k: string) => t(`submitDocuments.dependentDeduction.dependents.summary.${k}`);
  const yn = (v: string) =>
    v === 'yes'
      ? t('submitDocuments.dependentDeduction.spouse.yes')
      : v === 'no'
        ? t('submitDocuments.dependentDeduction.spouse.no')
        : '—';
  const lines: string[] = [];
  lines.push(`${L('fullName')}: ${d.fullName.trim()}`);
  if (d.fullNameKana.trim()) lines.push(`${L('fullNameKana')}: ${d.fullNameKana.trim()}`);
  lines.push(`${L('relationship')}: ${relationshipLabel(t, d) || '—'}`);
  if (d.dateOfBirth) lines.push(`${L('dob')}: ${d.dateOfBirth}`);
  if (d.myNumber.trim()) lines.push(`${L('myNumber')}: ${maskMyNumber(d.myNumber)}`);
  lines.push(`${L('sameHousehold')}: ${yn(d.livingInSameHousehold)}`);
  if (d.livingInSameHousehold === 'no' && d.ifNotAddress.trim()) {
    lines.push(`${L('address')}: ${d.ifNotAddress.trim()}`);
  }
  lines.push(`${L('sharedLivelihood')}: ${yn(d.sharedLivelihood)}`);
  if (d.estimatedIncome.trim()) lines.push(`${L('estimatedIncome')}: ${d.estimatedIncome.trim()}`);

  if (!d.eligible) {
    lines.push(
      `${L('outcome')}: ${t('submitDocuments.dependentDeduction.dependents.summary.ineligible')}`
    );
    return lines.join('\n');
  }

  const cats = deriveTaxCategories(d, taxYear);
  if (cats.length > 0) {
    lines.push(
      `${L('categories')}: ${cats
        .map((c) => t(`submitDocuments.dependentDeduction.dependents.category.${c}`))
        .join(', ')}`
    );
  }
  if (d.nonResident === 'yes' || d.nonResident === 'no') {
    lines.push(`${L('nonResident')}: ${yn(d.nonResident)}`);
  }
  if (d.nonResident === 'yes' && d.nonResidentReason) {
    lines.push(
      `${L('nonResidentReason')}: ${t(
        `submitDocuments.dependentDeduction.dependents.nonResidentReason.option.${d.nonResidentReason}`
      )}`
    );
    if (d.nonResidentReason === 'remittance_380k' && d.remittanceAmount.trim()) {
      lines.push(`${L('remittanceAmount')}: ${d.remittanceAmount.trim()}`);
    }
  }
  if (d.disabilityCategory) {
    lines.push(
      `${L('disability')}: ${t(`submitDocuments.profileName.disabilityCategory.option.${d.disabilityCategory}`)}`
    );
  }
  if (d.changeDuringYear === 'yes') {
    lines.push(
      `${L('change')}: ${[changeReasonAnswer(t, d), d.changeDate].filter(Boolean).join(' / ')}`
    );
  }
  return lines.join('\n');
}
